import { Box, Link, SxProps, Theme, useTheme } from "@mui/material";
import { Link as LinkRouter, useLocation } from "react-router-dom";
import { CircleHover } from "./CircleHover";

const getStyle = (theme: Theme) => {
  const link: SxProps<Theme> = {
    display: "flex",
    alignItems: "center",
    position: "relative",
    textDecoration: "none",
    textWrap: "nowrap",
    marginBlock: 1,
    textTransform: "capitalize",
    transition: "color 0.2s ease",
    "&:hover": {
      color: `${theme.palette.secondary.main}`,
    },
    "&:hover .circle-hover": {
      opacity: 1,
      scale: 1,
    },
  };
  const visibleHover: SxProps<Theme> = {
    "&:hover .circle-hover": {
      opacity: 1,
      scale: 1,
    },
  };
  const visible: SxProps<Theme> = {
    ".circle-hover": {
      opacity: 1,
      scale: 1,
    },
  };
  return { link, visibleHover, visible };
};

type ItemOptionPcProps = {
  item: string;
  to: string;
};
export const ItemOptionPc = ({ item, to }: ItemOptionPcProps) => {
  const theme = useTheme();
  const styles = getStyle(theme);
  const location = useLocation();
  const circleActive =
    to === location.pathname ? styles.visible : styles.visibleHover;

  return (
    <Box
      display="flex"
      position="relative"
      gap={1}
      sx={[
        styles.link,
        location.pathname === to ? styles.visible : circleActive,
      ]}
    >
      <CircleHover />
      <Link
        component={LinkRouter}
        to={to}
        variant="body2"
        color="textDisabled"
        sx={styles.link}
        className="cerrar-popover"
      >
        {item}
      </Link>
    </Box>
  );
};
